module.exports = __webpack_public_path__ + "static/media/emily.c3765e7a.jpeg";